<template>
  <div class="header-container" :class="{'dark': dark}">
    <div class="logo">
      <img v-if="dark" src="../assets/images/logo2.png" alt="">
      <img v-else src="../assets/images/logo1.png" alt="">
    </div>
    <div class="menu">
      <ul class="menu-list">
        <li :class="{active: active === 'Home'}" @click="$router.push('/')">首页</li>
        <li :class="{active: active === 'Product'}" @click="$router.push('/product')">产品介绍</li>
        <li :class="{active: active === 'Information'}" @click="$router.push('/information')">资讯中心</li>
        <li :class="{active: active === 'About'}" @click="false && $router.push('/about')">
          <a href="https://mp.weixin.qq.com/s/FXoIiYNIAqSvJboUg5qdVg" target="_blank">关于曼世</a>
        </li>
        <li :class="{active: active === 'Service'}" @click="$router.push('/service')">至臻服务</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: 'Home',
      hasBgColor: false
    }
  },
  mounted() {
    const curMenu = this.$route.name
    this.active = curMenu
    
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 0 &&!this.hasBgColor) {
        this.hasBgColor = true;
        this.addBgColor();
      } else if (scrollTop === 0 && this.hasBgColor) {
        this.hasBgColor = false;
        this.removeBgColor();
      }
    },
    addBgColor() {
      const header = this.$el;
      header.classList.add('has-bg-color');
    },
    removeBgColor() {
      const header = this.$el;
      header.classList.remove('has-bg-color');
    }
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 7.8125vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 11.9792vw;
  color: #F5F5F5;

  background-color: transparent; /* 初始背景色为透明 */
  transition: background-color 0.3s ease; /* 背景色过渡效果 */
  a {
    color: #F5F5F5;
  }
  &.dark {
    background-color: #ffffff;
    color: #333;
    a {
      color: #333;
    }
  }
  &.has-bg-color {
    background-color: rgba(0, 0, 0, 0.9); /* 滚动后添加的背景色，可调整透明度和颜色 */
    &.dark {
      background-color: #ffffff;
    }
  }
  .logo {
    height: 2.5vw;
    img {
      height: 100%;
    }
  }
  .menu {
    .menu-list {
      display: flex;
      li {
        margin-left: 2.5vw;
        font-size: 1.0417vw;
        cursor: pointer;
        &.active {
          font-weight: bold;
        }
      }
    }
  }
}

@media screen and (max-width: 768px ) {
  .header-container {
    height: 3.5625rem;
    line-height: 3.5625rem;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    .logo {
      height: 50%;
      transform: translateY(-25%);
      img {
        height: 100%;
      }
    }
    .menu-list {
      display: flex;
      li {
        font-size: .45rem !important;
      }
    }
  }
}
</style>